<template>
  <div v-if="isData()" class="container-fluid g-0 content__space" style="min-width: 800px !important">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="container-fluid">
              <div class="row" style="min-height: 130px">
                <div class="col-2">
                  <img src="img/icon/nettowin.png" alt="NetToWin" style="max-width: 140px !important">
                </div>
                <div class="col-8">
                  <p class="card-title">
                    <span style="font-size: 24px; font-weight: bold">
                      SOS24Aid–144
                    </span> <br/>
                    <span style="font-size: 18px; font-weight: bold">
                      Kundeninformation  / Informations pour les clients / Informazioni per i clienti
                    </span>
                  </p>
                </div>                
                <div class="col-2">
                  <img src="img/icon/sos24aid.png" alt="Sos24-Aid" style="max-width: 100px !important">
                </div>
              </div>
              
            </div>
            <p class="card-text" style="min-height: 6px !important"><small class="text-muted"></small></p>
            <p class="card-text d-flex justify-content-start text-muted">
              <button v-if="!isStandAlone" type="button" 
                @click.prevent="onButtonCollapse"
                class="btn btn-outline-primary">
                  Zuklappen
              </button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Bereich / Zone / Zona: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ customer.info.bereichName }}
            </p>
            <p class="card-text"><small class="text-muted"></small></p>

            <div class="container-fluid">
              <div class="row">
                <div class="col-4">

                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title"></h5>
                      <p class="card-text"><small class="text-muted">Hautpverantwortlich / Principal responsable (SiBe, COSEC)</small></p>
                      <div class="container-fluid">
                        <div 
                          class="row"
                          v-for="(item, id) in getCustomerPeople('Kunde')"
                          v-bind:key="id"
                        >
                          <div class="col-12 d-flex" style="text-align: left">
                            {{ item.organisation}} <br />
                            {{ item.firma}} <br />
                            {{ item.name }} <br />
                            {{ item.email }} <br />
                            {{ item.phone }} <br />
                            {{ item.cellPhone }} <br />

                            <br />                            
                            {{ item.strasseMitHausnummer }} <br />
                            {{ item.pLzOrt }} <br />
                            {{ item.adresszusatz1 }} <br />
                            {{ item.land }} <br />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <!-- Card Col  -->
                <div class="col-4">

                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title"></h5>
                      <p class="card-text"><small class="text-muted">Verantwortlich Technik / Responsable technologie</small></p>


                      <div class="container-fluid">
                        <div 
                          class="row"
                          v-for="(item, id) in getCustomerPeople('Service')"
                          v-bind:key="id"
                        >
                          <div class="col-12 d-flex" style="text-align: left">
                            {{ item.organisation}} <br />
                            {{ item.firma}} <br />
                            {{ item.name }} <br />
                            {{ item.email }} <br />
                            {{ item.phone }} <br />
                            {{ item.cellPhone }} <br />

                            <br />                            
                            {{ item.strasseMitHausnummer }} <br />
                            {{ item.pLzOrt }} <br />
                            {{ item.adresszusatz1 }} <br />
                            {{ item.land }} <br />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <!-- Card Col  -->

                <div class="col-4">

                  <div class="card">
                    <div class="card-body">
                      <h5 class="card-title"></h5>
                      <p class="card-text"><small class="text-muted">Rechnungskontakt / Contact de facturation</small></p>


                      <div class="container-fluid">
                        <div 
                          class="row"
                          v-for="(item, id) in getCustomerPeople('Faktura')"
                          v-bind:key="id"
                        >
                          <div class="col-12 d-flex" style="text-align: left">
                            {{ item.organisation}} <br />
                            {{ item.firma}} <br />
                            {{ item.name }} <br />
                            {{ item.email }} <br />
                            {{ item.phone }} <br />
                            {{ item.cellPhone }} <br />

                            <br />                            
                            {{ item.strasseMitHausnummer }} <br />
                            {{ item.pLzOrt }} <br />
                            {{ item.adresszusatz1 }} <br />
                            {{ item.land }} <br />
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>
                <!-- Card Col  -->


              </div>


            </div>  
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Ihre Rettungsdaten / Vos données de sauvetage / I tuoi dati di salvataggio</h5>
            <p class="card-text"></p>
            <p class="card-text"><small class="text-muted"></small></p>
            <div class="container-fluid">
              <div 
                class="row"
                v-for="(item, id) in getRettungsdaten(customerLinks.documents)"
                v-bind:key="id"
              >
                <div class="col-12 d-flex justify-content-between">
                  <a v-bind:href="item.dokumentUrl" target="_blank">
                   {{ translateName( item.dokumentTyp ) }} -  {{ item.datum }}
                  </a>
                </div>
              </div>
              <!--div class="row">
                <div class="col-12">
                  Dieser Service ist infolge Wartungsarbeiten nicht verfügbar !
                  Ce service n'est pas disponible en raison de travaux de maintenance !
                  Questo servizio non è disponibile a causa di lavori di manutenzione!
                </div>
              </div-->
              <div v-if="!isStandAlone" class="row">
                <div class="col-12 d-flex justify-content-start">
                   <button type="button" 
                    @click.prevent="onRettungsdatenRefresh"
                    class="btn btn-outline-primary mt-4">
                      Rettungsdaten aktualisieren
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="card-group">
          <div v-if="isBestellAnforderung()" class="card">
            <div class="card-body">
              <h5 class="card-title">Ihre Bestellanforderung / Votre demande d'achat / La tua richiesta di acquisto</h5>
              <p class="card-text"></p>
              <p class="card-text">
                <small class="text-muted"></small>
              </p>
              <div class="container-fluid">
                <div
                  class="row"
                  v-for="(item, id) in getBestellanforderungen(
                    customerLinks.documents
                  )"
                  v-bind:key="id"
                >
                  <div class="col-12 d-flex justify-content-between">
                    <a v-bind:href="item.dokumentUrl" target="_blank">
                      {{ translateName(item.dokumentTyp) }}
                    </a>
                  </div>
                </div>
                <div v-if="isBestellAnforderungEingabe()" class="row mt-4" style="min-height: 70px !important">
                  <div class="col d-flex justify-content-start">
                    <form @submit.prevent="createCustomerBestellnummer()" class="form-signin">
                      <div class="row">
                        <div class="col">
                          <span style="white-space: wrap; font-size: 0.9rem">Ihre Bestellnummer / Votre numéro de commande / Il tuo numero d'ordine</span> 
                        </div>
                      </div>
                       <div class="row">
                        <div class="col">
                          <input type="text" id="bestellNummer" class="form-control" placeholder="" autocomplete="off" spellcheck="false" autocorrect="off" autocapitalize="off" v-model="bestellNummer"/>
                        </div>                                                
                      </div>
                      <div class="row centered mt-4">
                        <div class="col-10 d-flex justify-content-end">
                          <button :disabled="savedDisabled" class="btn btn-primary form__button--view">Nummer  übermitteln / transmission / trasmettere</button>
                        </div>
                        <div v-if="saved" class="col saved">
                          <img src="img/icon/icons8-ok-48.png" alt="Ok ...">
                        </div>                        
                      </div>
                    </form>
                  </div>
                </div>

                <div v-if="!isBestellAnforderungEingabe()" class="row mt-4">
                  <div class="col d-flex justify-content-center">
                    <form class="form-signin">
                      <div class="row" style="min-height: 30px">
                        <div class="col">
                          <span style="white-space: wrap !important; font-size: 0.9rem">Ihre Bestellnummer / Votre numéro de commande / Il tuo numero d'ordine</span>                          
                        </div>
                      </div>
                        <div class="row">
                        <div class="col field__value">
                          <label style="font-weight: bold; font-size: 1.4rem">{{ bestellNummer }}</label>
                        </div>
                        <div class="col-2"></div>
                      </div>
                    </form>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <div v-if="isRechnung() && !isReminder()" class="card">
            <div class="card-body">
              <h5 class="card-title">Ihre Rechnungen / Vos factures  / Le tue fatture</h5>
              <p class="card-text"></p>
              <p class="card-text"><small class="text-muted"></small></p>
              <div class="container-fluid">
                <div
                  class="row"
                  v-for="(item, id) in getInvoice(customerLinks.documents)"
                  v-bind:key="id"
                >
                  <div class="col-12 d-flex justify-content-between">
                    <a v-bind:href="item.dokumentUrl" target="_blank">
                      {{ translateName(item.dokumentTyp) }} {{item.bestellInformation}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isReminder()" class="card">
            <div class="card-body">
              <h5 class="card-title">Mahnung zur Zahlung / Rappel de paiement / Promemoria di pagamento</h5>
              <p class="card-text"></p>
              <p class="card-text"><small class="text-muted"></small></p>
              <div class="container-fluid">
                <div
                  class="row"
                  v-for="(item, id) in getReminder(customerLinks.documents)"
                  v-bind:key="id"
                >
                  <div class="col-12 d-flex justify-content-between">
                    <a v-bind:href="item.dokumentUrl" target="_blank">
                      {{ translateName(item.dokumentTyp) }} {{item.bestellInformation}}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
  <div v-if="spinner" class ="spinner__centered">
    <img src="img/icon/icons8-spinner.gif" alt="Bitte warten ...">
  </div>
</template>

<script>
import { reactive, ref, watch , onMounted} from "vue";
import { apiPost } from "@/services/api/fetchapi";
import { constructDocuments } from "./DtoCustomerReport";

export default {
  name: "DocumentAccess",
  inheritAttrs: false,
  props: ["customerLink","Year","standAlone"],
  components: {},
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    const isCollapsed = ref(false);

    const spinner = ref(false);
    const saved = ref(false);
    const savedDisabled = ref(false);
   
    const customerLinks = reactive({
      documents: constructDocuments(),
    });

    const customer = reactive({
      info: {},
    });

    const isStandAlone = ref(props.standAlone);
    const customerId = ref(props.customerLink);
    const bestellNummer = ref("");

    function onButtonCollapse() {
      isCollapsed.value = true;
    }

    function onRettungsdatenRefresh() {
      spinner.value = true;
      createRettungsdaten(true);
    }

    function getCustomerPeople( filter ) {
      return customer.info.personen.filter((row) => {
        if (row.role == filter) {
          return true;
        }
      });
    }

    function getInvoice() {
      return customerLinks.documents.filter((row) => {
        console.log(row);
        if (
          row.dokumentTyp == "Rechnung"           
        ) {
          return true;
        }
      });
    }

    function getReminder() {
      return customerLinks.documents.filter((row) => {
        console.log(row);
        if (
          row.dokumentTyp == "Mahnung"           
        ) {
          return true;
        }
      });
    }

    function getBestellanforderungen() {
      return customerLinks.documents.filter((row) => {
        console.log(row);
        if (
          row.dokumentTyp == "Bestellung" ||
          row.dokumentTyp == "Brief Bestellung"
        ) {
          return true;
        }
      });
    }

    function getRettungsdaten() {
      return customerLinks.documents.filter((row) => {        
        if (
          row.dokumentTyp == "Stammblatt" ||
          row.dokumentTyp == "Rettungsdaten" || 
          row.dokumentTyp == "Brief Rechnung"
        ) {
          return true;
        }
      });
    }

    function isBestellAnforderung() {
      let temp = false;
      if (customerLinks.documents.length > 0) {
        customerLinks.documents.forEach((row) => {
          if (row.vorgangsTyp === "Bestellung + Rechnung") {
            temp = true;
          }
        });
      }
      return temp;
    }

    function isRechnung() {
      let temp = false;
      if (customerLinks.documents.length > 0) {
        customerLinks.documents.forEach((row) => {
          if (
            row.vorgangsTyp === "Rechnung" ||
            row.vorgangsTyp === "Bestellung + Rechnung"
          ) {
            temp = true;
          }
        });
      }
      return temp;
    }


    function isReminder() {
      let temp = false;
      if (customerLinks.documents.length > 0) {
        customerLinks.documents.forEach((row) => {
          if (row.dokumentTyp === "Mahnung") {
            temp = true;
          }
        });
      }
      return temp;
    }

    function isData() {
      if ( isCollapsed.value ) {
        return false;
      }

      if (customerLinks.documents.length > 0) {
        return true;
      }
      return false;
    }

    function isBestellAnforderungEingabe() {
      let temp = true;
      if (customerLinks.documents.length > 0) {
        customerLinks.documents.forEach((row) => {
          if (row.bestellnummerGesperrt) {
            temp = false;
          }
        });
      }
      return temp;
    }

    async function getCustomerInfo() {
      try {

        const link = customerId.value.replace("###", "");
        const customerOpened = isStandAlone.value;

        const response = await apiPost("ComponentView/getCustomerInfo", {
          customerOpened: customerOpened,
          link: link,
          Year: props.Year,
        });
        customer.info = JSON.parse(JSON.stringify(response));
        console.log(customer.info)
      } catch (e) {
        console.log("Error" + e);
      }
    }

    async function createRettungsdaten(alwaysCreate) {
      const docFilePath = process.env.VUE_APP_FILEPATH;
      const docUrl = process.env.VUE_APP_DOCUMENTURL;
      const customerLink = process.env.VUE_APP_CUSTOMERLINKURL;
      const link = customerId.value.replace("###", "");
      const customerOpened = isStandAlone.value;

      let doCreate = customerOpened;
      //doCreate = false;
      if ( alwaysCreate ) {
        doCreate = true;
      }

      doCreate = false;
      const temp = await apiPost("ComponentView/createReport", {
        customerOpened: doCreate,
        link: link,
        Year: props.Year,
        action: "Rettungsdaten",
        documentFilePath: docFilePath,
        documentUrl: docUrl,
        CustonerLinkBasePath: customerLink
      });

      getCustomerDocuments();
    }

    async function getCustomerDocuments() {
      try {
        const link = customerId.value.replace("###", "");

        const response = await apiPost(
          "ComponentView/getCustomerDocumentLinks",
          {
            link: link,
            Year: props.Year,
          }
        );
        customerLinks.documents = JSON.parse(JSON.stringify(response));
        if (customerLinks.documents.length > 0) {
          bestellNummer.value = customerLinks.documents[0].bestellnummer;
        }

        spinner.value = false;
      } catch (e) {
        console.log("Error" + e);
        spinner.value = false;
      }
    }

    async function createCustomerBestellnummer() {
      try {
        spinner.value = true;
        saved.value = false;
        savedDisabled.value = true;
        const year = props.Year;
        const link = customerId.value.replace("###", "");

        const response = await apiPost(
          "ComponentView/createCustomerBestellnummer",
          {
            link: link,
            requisitionNumber: bestellNummer.value,
            Year: year
          }
        );
        saved.value = true; 
      } catch (e) {
        console.log("Error" + e);
      }
      spinner.value = false;
      const timerId = setTimeout(() => { waitForReset() }, 10000);
    }


    function waitForReset() {
      savedDisabled.value = false;
    }
    // getCustomerDocuments();
    watch(
      () => props.customerLink,
      (newValue) => {
        spinner.value = true;
        isCollapsed.value = false;
        customerId.value = newValue;        
        saved.value = false;
        bestellNummer.value = "";
        savedDisabled.value = false;
        isStandAlone.value = props.standAlone;
        getCustomerInfo();
        createRettungsdaten(false);
      }
    );

    function translateName( typTitle ) {
      if (typTitle === "Brief Rechnung") {
        return "Wichtige Hinweise / Remarque importante / Nota importante !";
      }
      if (typTitle === "Rechnung") {
        return "Rechnung / Facture / Fattura";
      }
      if (typTitle === "Brief Bestellung") {
        return "Brief Bestellung / Lettre de commande / Lettera d'ordine";
      }
      if (typTitle === "Bestellung") {
        return "Bestellung / commande / ordine";
      }
      if (typTitle === "Rettungsdaten") {
        return "Rettungsdaten / Données de sauvetage / Dati di salvataggio";
      }
      return typTitle;
    }

    onMounted(() => {
      if( !isStandAlone.value) return
      if (localStorage.getItem('documentReloaded')) {
        localStorage.removeItem('documentReloaded');        
    } else {
        localStorage.setItem('documentReloaded', '1');
        setTimeout( () => {location.reload()}  ,100);
        
        
    }
    });

    return {
      customerLinks,
      customerId,
      bestellNummer,
      getInvoice,
      getBestellanforderungen,
      isRechnung,
      isBestellAnforderung,
      isBestellAnforderungEingabe,
      getReminder,
      isReminder,
      isData,
      getRettungsdaten,
      createCustomerBestellnummer,
      spinner,
      saved,
      customer,
      savedDisabled,
      getCustomerPeople,
      isCollapsed,
      onButtonCollapse,
      isStandAlone,
      translateName,
      onRettungsdatenRefresh,
    };
  },
};
</script>
<style lang="scss" scoped>
.spinner__centered {
  position: fixed;
  left: 460px;
  top: 400px;
  z-index: 999;
}

.content__space {
  margin-top: 3%;
  margin-bottom: 3%;
  max-width: 94% !important;
}

  .centered {
    align-items: flex-end;
    
  }

  .field__label {
    max-width: 180px;
    padding-top: 5px;
    padding-bottom: 2px;
    text-align: left;
  }

  .field__label--check {
    max-width: 180px;
    padding-top: 5px;
    padding-bottom: 2px;
    text-align: right;
    padding-right: 10px;
  }


.field__value {
    max-width: 500px;
    width: 500px;
  }

</style>
